import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';

import { withActions } from '../../WithActions';
import MediaRecordingActions from "../../actions/MediaRecordingActions";

import Recorder from '../../recorder/ui/Recorder';
import RecorderView from '../../recorderView/ui/RecorderView';
import IViewQueryParams from '../../recorderView/ui/IViewQueryParams';

const VIEW_DEFAULTS_QUERY_PARAMS: IViewQueryParams = {
  videoId: 'default',
  edit: false,
  stopRedirect: false,
  changeShareBtn: false
};

function getQueryParams<T>(searchString: string, defaults: T): T {
  const queryParams: T | any = {} as T;
  const nameValuePairs: string[] = searchString.substr(1).split('&');
  if (searchString !== 'undefined' && searchString !== '') {
    for (const nameValue of nameValuePairs) {
      const [name, value] = nameValue.split('=');

      //if (defaults.hasOwnProperty(name)) {
        if (value === 'false') {
          queryParams[name] = false;
        } else if (value === 'true') {
          queryParams[name] = true;
        } else {
          queryParams[name] = value;
        }
      //} else {
        //console.log('Non existent query param: ' + name + ' = ' + value);
      //}
    }

    for (const param in defaults) {
      if (typeof queryParams[param] !== 'undefined') {
        defaults[param] = queryParams[param];
      }
    }

  }

  return defaults;
}



interface Props {
  actions: MediaRecordingActions;
  width: string
}

interface State {
  sourceSelected: number,
  isAudioAllowed: boolean,
  isVideoAllowed: boolean
}
         
class RecorderMain extends React.Component<Props, State> {
  
  constructor(props: Props) {
    super(props);
    this.state = {
      sourceSelected: this.props.actions.getRecordSourceSelected(),
      isAudioAllowed: this.props.actions.getAudioAllowed(),
      isVideoAllowed: this.props.actions.getVideoAllowed()
    };
  } 
  
  handleChangeSourceSelected = (index: number) => {
    this.props.actions.setRecordSourceSelected(index)
    this.setState({
      sourceSelected: index
    });
  } 

  handleChangeAudioAllowed = (value: boolean) => {
    this.props.actions.setVideoAllowed(value)
    this.setState({
      isAudioAllowed: value
    });
  }   
  
  handleChangeVideoAllowed = (value: boolean) => {
    this.props.actions.setVideoAllowed(value)
    this.setState({
      isVideoAllowed: value
    });
  }   

  render() {
    const { sourceSelected, isAudioAllowed, isVideoAllowed } = this.state;

    return(
      <main>
      <Switch>
        <Route
          path="/"
          strict={true}
          exact={true}
          render={(props) => {
            const queryParams = getQueryParams(props.location.search, VIEW_DEFAULTS_QUERY_PARAMS);
            return (<Recorder
              {...props}
              queryParams={queryParams}
              handleChangeSourceSelected={this.handleChangeSourceSelected}
              handleChangeAudioAllowed={this.handleChangeAudioAllowed}
              handleChangeVideoAllowed={this.handleChangeVideoAllowed}
              sourceSelected={sourceSelected}
              isAudioAllowed={isAudioAllowed}
              isVideoAllowed={isVideoAllowed}
            />)
          }}
        />
        <Route
          path="/view"
          strict={true}
          exact={true}
          render={(props) => {
            const queryParams = getQueryParams(props.location.search, VIEW_DEFAULTS_QUERY_PARAMS);
            return (<RecorderView
              {...props}
              queryParams={queryParams}
            />)
          }}
        />
        <Redirect from="/" to="/" />
        <Redirect from="/view/" to="/view" />
      </Switch>
    </main>      
    )
  }
}

export default withActions(RecorderMain);



